import React, { useState } from 'react';

const YapeModal = ({ 
  showModal, 
  yapePurchaseData, 
  confirmationCode, 
  setConfirmationCode, 
  receiptFile, 
  submittingYape, 
  onFileUpload, 
  onSubmit, 
  onClose, 
  user 
}) => {
  const [imageError, setImageError] = useState(false);

  if (!showModal || !yapePurchaseData) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#6B2C91', color: 'white' }}>
            <h5 className="modal-title">
              <i className="bi bi-phone me-2"></i>
              Pago con Yape
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              {/* Columna izquierda - solo QR grande */}
              <div className="col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="text-center mb-4 w-100">
                  <h6 className="mb-3" style={{ color: '#6B2C91' }}>
                    <i className="bi bi-qr-code me-2"></i>
                    Escanea el código QR
                  </h6>
                  {/* QR Code */}
                  <div className="bg-light border rounded p-4 mb-3 d-flex justify-content-center">
                    <div className="rounded p-3 text-center" style={{ backgroundColor: '#f8f9fa' }}>
                      {!imageError ? (
                        <img 
                          src="/qr.jpeg"
                          alt="Código QR para Yape" 
                          className="img-fluid rounded"
                          style={{ maxWidth: '400px', maxHeight: '420px', minWidth: '220px', minHeight: '220px' }}
                          onLoad={() => {
                            setImageError(false);
                          }}
                          onError={() => {
                            setImageError(true);
                          }}
                        />
                      ) : (
                        <div className="alert alert-danger py-4">
                          <i className="bi bi-shield-exclamation display-5 mb-2"></i>
                          <div className="mt-2">
                            <strong>¡Atención!</strong><br />
                            <span>No se pudo cargar el código QR de Yape.<br />Por seguridad, no realices pagos si no ves el QR oficial del negocio.</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="alert alert-info small">
                    <i className="bi bi-info-circle me-2"></i>
                    <strong>Monto a pagar: S/ {yapePurchaseData.totalAmount}</strong>
                  </div>
                </div>
              </div>

              {/* Columna derecha - Formulario de comprobante */}
              <div className="col-md-6">
                <div className="border rounded" style={{ borderColor: '#6B2C91 !important' }}>
                  <div className="card-header text-white py-2" style={{ backgroundColor: '#6B2C91' }}>
                    <h6 className="mb-0">
                      <i className="bi bi-receipt m-2"></i>
                      Comprobante de Pago
                    </h6>
                  </div>
                  <div className="card-body">
                    {/* Resumen de la compra */}
                    <div className="mb-3 m-2">
                      <div className="d-flex justify-content-between mb-1">
                        <span>Documentos:</span>
                        <strong>{yapePurchaseData.documentCount.toLocaleString()}</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span>Precio base:</span>
                        <span>S/ {yapePurchaseData.originalPrice}</span>
                      </div>
                      {yapePurchaseData.discount > 0 && (
                        <div className="d-flex justify-content-between mb-1">
                          <span style={{ color: '#6B2C91' }}>Descuento:</span>
                          <span style={{ color: '#6B2C91' }}>-S/ {yapePurchaseData.discount}</span>
                        </div>
                      )}
                      <hr className="my-2" />
                      <div className="d-flex justify-content-between">
                        <strong>Total pagado:</strong>
                        <strong className="h5 mb-0" style={{ color: '#6B2C91' }}>S/ {yapePurchaseData.totalAmount}</strong>
                      </div>
                    </div>

                    {/* Instrucciones */}
                    <div className="bg-light rounded p-3 mb-3">
                      <h6 className="text-dark mb-2">📋 Instrucciones:</h6>
                      <ol className="small mb-0 ps-3">
                        <li>Abre tu app de Yape</li>
                        <li>Escanea el código QR mostrado a la izquierda</li>
                        <li>Confirma el pago por el monto indicado: <strong>S/ {yapePurchaseData.totalAmount}</strong></li>
                        <li>Sube tu comprobante o ingresa el número de operación</li>
                      </ol>
                    </div>

                    {/* Código de confirmación */}
                    <div className="mb-3 m-2">
                      <label className="form-label">
                        <i className="bi bi-key me-1"></i>
                        Número de operación (opcional)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ej: 1234567890"
                        value={confirmationCode}
                        onChange={(e) => setConfirmationCode(e.target.value)}
                      />
                      <small className="text-muted">Puedes encontrarlo en tu app de Yape</small>
                    </div>

                    {/* Upload de imagen */}
                    <div className="mb-3 m-2">
                      <label className="form-label">
                        <i className="bi bi-image me-1"></i>
                        Subir captura de pantalla
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={onFileUpload}
                      />
                      {receiptFile && (
                        <div className="mt-2">
                          <small style={{ color: '#6B2C91' }}>
                            <i className="bi bi-check-circle me-1"></i>
                            Archivo seleccionado: {receiptFile.name}
                          </small>
                        </div>
                      )}
                    </div>

                    <div className="alert alert-warning small">
                      <i className="bi bi-exclamation-triangle me-2"></i>
                      Proporciona al menos el número de operación o la imagen del comprobante
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <div className="row w-100 g-2">
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-secondary w-100"
                  onClick={onClose}
                >
                  Cancelar
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  className="btn text-white w-100"
                  style={{ backgroundColor: '#6B2C91', borderColor: '#6B2C91' }}
                  onClick={() => onSubmit(user)}
                  disabled={submittingYape || (!confirmationCode && !receiptFile)}
                >
                  {submittingYape ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-send me-2"></i>
                      Enviar Comprobante
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YapeModal;
